import React, { FC } from "react";
import { Text } from "react-native-elements";
import { TextStyle } from "react-native";
import { useNavigation } from "@react-navigation/native";
import { OpenStackParamList, linking } from "../../App";

export const TextLink: FC<
  | {
      type: "route";
      routeName: keyof OpenStackParamList;
      children: string;
      style?: TextStyle;
    }
  | {
      type: "href";
      href: string;
      children: string;
      style?: TextStyle;
      target?: "_blank";
    }
> = (props) => {
  const navigation = useNavigation();

  const onPress =
    props.type === "route"
      ? () => navigation.navigate("Open", { screen: props.routeName })
      : undefined;
  const attrs =
    props.type === "route"
      ? { href: "/" + linking.config.screens.Open.screens[props.routeName] }
      : { href: props.href, target: props.target };
  return (
    <Text
      style={props.style}
      accessibilityRole="link"
      onPress={onPress}
      {...attrs}
    >
      {props.children}
    </Text>
  );
};
